import styled from "styled-components";
import {size} from "../../helpers/breakpoints";

export const Container = styled.div`
  flex: 1;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--main-color);
  transition: .3s;
  scroll-behavior: smooth;
  
  @media only screen and (max-width: ${size.xl}) {
    position: absolute;
    width: ${props => props.openInMobile ? '100vw' : '0'};
    z-index: 44;
    top: 0;
    right: 0;
  }
`;

export const WriteMessageContainer = styled.div`
  width: 100%;
  background-color: var(--main-color);
  border-top:1px solid var(--border-color);
  position: sticky;
  height: 70px;
  margin-top: auto;
  padding: 0 .7rem;
  bottom: 0;
`;

export const WriteMessageInput = styled.textarea`
  width: 100%;
  background-color: var(--main-color);
  position: relative;
  border: none;
  height: 100%;
  padding: 29px .7rem 2rem 1rem;
  font-size: .8rem;
  color: var(--main-text-color);
  resize: none;
  
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #bbb;
  }
  //&::after {
  //  content: 'vvd';
  //  display: inline;
  //}
`;

export const SendButton = styled.button`
  min-width: 50px;
  max-width: 50px;
  min-height: 50px;
  max-height: 50px;
  border-radius: 50%;
  opacity: .85;
  background-color: var(--accent-color);
  color: #FFF;
  border: none;
  transition: .2s;

  &:hover {
    opacity: 1;
  }

  &:active {
    outline: none;
    opacity: .9;
  }
`;

export const SendIcon = styled.i`
  &::before {
    font-size: 1.2rem;
  }
`;

export const ImojiIcon = styled.i`
  &::before {
    font-size: 1.2rem;
  }
`;
